"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Particles = void 0;
var _pixi = require("pixi.js");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Particles = exports.Particles = /*#__PURE__*/function (_ParticleContainer) {
  function Particles() {
    var _this;
    _classCallCheck(this, Particles);
    _this = _callSuper(this, Particles);
    _defineProperty(_this, "pool", void 0);
    _defineProperty(_this, "particles", void 0);
    _defineProperty(_this, "count", void 0);
    _defineProperty(_this, "tick", void 0);
    _defineProperty(_this, "particles_tex", ['star.png']);
    _defineProperty(_this, "starTexture", void 0);
    _this.pool = [];
    _this.particles = [];
    _this.starTexture = _pixi.Texture.from(_this.particles_tex[0]);
    return _this;
  }
  _inherits(Particles, _ParticleContainer);
  return _createClass(Particles, [{
    key: "spawn",
    value: function spawn() {
      var number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;
      for (var i = 0; i < number; i++) {
        this.addParticles();
      }
    }
  }, {
    key: "addParticles",
    value: function addParticles() {
      var particles = this.pool.pop();
      if (!particles) {
        particles = new _pixi.Sprite(
        //Texture.from(this.particles_tex[Math.floor(Math.random() * this.particles_tex.length)])
        this.starTexture);
        particles.anchor.set(0.5);
        particles.blendMode = _pixi.BLEND_MODES.SCREEN;
        particles.speed = new _pixi.Point();
      }
      particles.scale.x = particles.scale.y = 0;
      var scale = Math.random() * (1.8 - 0.5) + 0.5;
      _gsap["default"].to(particles.scale, {
        duration: 1,
        x: scale,
        y: scale,
        ease: 'elastic.out'
      });
      particles.alpha = Math.random() * 0.3 + 0.69;
      particles.position.x = 0;
      particles.position.y = 0;
      particles.speed.x = Math.random() * (20 + 20) - 20;
      particles.speed.y = Math.random() * (20 + 20) - 20;
      particles.amplitude = Math.random();
      particles.tick = Math.random() * Math.PI * 2;
      particles.tickLife = Math.random() * 0.05 + 0.01;
      this.addChild(particles);
      this.particles.push(particles);
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      _superPropGet(Particles, "updateTransform", this, 3)([]);
      this.count += 0.02;
      this.tick++;
      for (var i = 0; i < this.particles.length; i++) {
        var b = this.particles[i];
        b.tick++;
        b.position.x += b.speed.x;
        b.position.y += b.speed.y;
        b.speed.x *= 0.94;
        b.speed.y *= 0.94;
        b.rotation += 0.1;
        b.speed.y += 0.3;
        b.alpha -= b.tickLife;
        if (b.alpha < 0.05) {
          this.pool.push(b);
          this.particles.splice(i, 1);
          this.removeChild(b);
          i--;
        }
      }
    }
  }]);
}(_pixi.ParticleContainer);
//# sourceMappingURL=Particles.js.map